export const PopupStatus = {
    OPEN: 'open',
    CLOSED: 'closed'
};
